import { render, staticRenderFns } from "./AddShop.vue?vue&type=template&id=31d85152&scoped=true"
import script from "./AddShop.vue?vue&type=script&lang=ts"
export * from "./AddShop.vue?vue&type=script&lang=ts"
import style0 from "./AddShop.vue?vue&type=style&index=0&id=31d85152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d85152",
  null
  
)

export default component.exports